import { PredefinedFilter } from './predefined-filter';
import { AttributeDefinition } from './server/attribute-definition';
import { ColumnDefinition } from './server/column-definition';
import { ViewType } from './server/enums/view-type';
import { ListLayout } from './server/list-layout';

/**
 * Représente la configuration d'une liste de dossiers.
 */
export class FoldersListConfiguration {
    /**
     * Constructeur
     * @param viewId: Id de la vue.
     * @param viewType : Type de vue.
     * @param listLayout : Mise en page à appliquer à la liste des dossiers.
     * @param columnDefinitions :  Définitions des colonnes affichées.
     * @param attributeDefinitions : Définitions des attributs utilisées par les filtres
     * @param predefinedFilters  : Liste des filtres prédéfinis de la vue.
     * @param defaultFilter : Filtre à appliquer par défaut à la liste des dossiers.
     */
    constructor(
        public viewId: number,
        public viewType: ViewType,
        public listLayout: ListLayout,
        public columnDefinitions: ColumnDefinition[],
        public attributeDefinitions: AttributeDefinition[],
        public predefinedFilters: PredefinedFilter[],
        public defaultFilter: PredefinedFilter
    ) {}
}
